import React from "react";

import "../../App.css";

import Button from "@mui/material/Button";

import { useHistory, useLocation } from "react-router-dom";

import { Checkbox } from "@mui/material";

import { useState, useEffect, useRef } from "react";

import CircularProgress from "@mui/material/CircularProgress";

import Modal from "@mui/material/Modal";

import CheckCircleIcon from "@mui/icons-material/CheckCircle";

import LoaderComponent from "./loader";

import { useBulkProcessing } from "../../contexts/BulkProcessingContext";

import InstaColors, {
  DeleteButton,
  EditButton,
  fontFamily,
  paddingAndMargin,
  reviewScreenButtonWithColor,
  reviewScreenButtonWithOutColor,
  screenHeaderStyle,
  UpperLowerText,
  useSharedValue,
} from "../Constants/constants";

import { ConditionalPagination } from "../../utils/paginationUtils";

import "../App.css";

import { BASE_URL } from "../../App_Settings/app_settings";
import { handleFileDelete } from "../../services/deleteService";
import DeleteModal from "../Models/Delete/DeleteModal";
import { ParallelProcessModal } from "../Models/Parallel Process Modal/ParallelProcessModal.tsx";
import {
  handleFileUpload,
  getUploadTypeDisplayName,
  columns,
} from "../../Controller/fileController.tsx";

import SearchInput from "../Constants/search_input";

import { formatDate, getAllFilesList } from "../../Utility/utility";

import NotificationService from "../../services/notificationService";

import { v4 as uuidv4 } from "uuid";

import Loader from "../../Utility/loading";

import "../App.css";

import { getUserFileAuditByUserId } from "../../API_Endpoints/APIEndpoints";

import { handleLogout } from "../../Utility/utility";

export default function BulkFormImport() {
  const [isLoading, setIsLoading] = useState(false);

  // Use context for persistent processing state across navigation
  const {
    processingStatus,
    startProcessing,
    isFileProcessing,
    setOnAllCompleteCallback,
    selectedRows,
    handleSelectedRows,
  } = useBulkProcessing();

  const { notifications, handleNotificationList } = useSharedValue();

  const [temporarySelectedRows, setTemporarySelectedRows] = useState([]);

  const { selectedRow } = useSharedValue();

  const { successFilename } = useSharedValue();

  const { isSuccessPopup, handleIsSuccessPopup } = useSharedValue();

  const { DataExtractProcess } = useSharedValue();

  const { storeReports } = useSharedValue();

  // const { searchValue } = useSharedValue();

  const processContainerRef = useRef(null);

  const [searchValue, setSearchValue] = useState("");

  const [selectDeletedItem, setSelectDeletedItem] = useState(null);

  const [isPopupOpen, setIsPopupOpen] = useState(false);

  const { extractLimit } = useSharedValue();

  const [editingData, setEditingData] = React.useState(null);

  const [userName, setUserName] = useState("");

  const { defaultBusinessunit, defaultOrganization, defaultUser, businessUnitsList } =
    useSharedValue();

  const [userId, setuserId] = useState(null);

  const [rows, setRows] = useState([]);

  const [allFiles, setAllFiles] = useState([]);

  const { isMenuOpen } = useSharedValue();

  const [fileName, setFileName] = React.useState("");

  const [businessUnits, setBusinessUnits] = React.useState([]);

  const [id, setId] = React.useState("");

  const [businessUnit, setBusinessUnit] = React.useState("");

  const [numberOfDataRows, setDataRows] = React.useState("");

  const [numberOfTiers, setTiers] = React.useState("");

  // const classes = useStyles();

  const { handleUserTraiLimit } = useSharedValue();

  const [isCheckedAll, setIsCheckedAll] = useState(false);

  const [uploadedDate, setUploadedDate] = React.useState("");

  const [processIdentifier, setProcessIdentifier] = React.useState("AI Extrcator - I");

  const [units, setUnits] = React.useState(["Select"]);

  const process = ["DOC-AI", "GPT-AI"];

  const { numberOfSelectedRows, updateRowNumberOfPages } = useSharedValue();

  const [startIndex, setStartIndex] = useState(0); // Initial rows per page value

  const [currentPage, setCurrentPage] = useState(1); // Current page number

  const [rowsPerPage, setRowsPerPage] = useState(10);

  const [endIndex, setEndIndex] = useState(10);

  // Calculate total pages based on filtered rows
  const filteredRows = rows.filter((item) => item.isProcessed === false);
  //   const totalPages = Math.ceil(filteredRows.length / rowsPerPage);

  // Synchronize endIndex with rowsPerPage and currentPage
  useEffect(() => {
    setEndIndex((currentPage - 1) * rowsPerPage + rowsPerPage);
  }, [rowsPerPage, currentPage]);

  const history = useHistory();
  const location = useLocation();
  const hasProcessedExtractData = useRef(false);
  const [pendingExtractFileId, setPendingExtractFileId] = useState(null);

  // const [isRunProcessStarted, setIsRunProcessStarted] = useState(false);

  const [loading, setLoading] = useState(true);

  const { isProcessing, processStates } = useSharedValue();

  // Separate Withholding Statement from other documents

  // Calculate form type counts

  const [isDeleting, setIsDeleting] = useState(false);

  // State for tracking parallel upload progress
  const [uploadProgress, setUploadProgress] = useState({});
  const [isParallelUploading, setIsParallelUploading] = useState(false);

  // Format elapsed time as MM:SS or HH:MM:SS if over an hour

  // Handle auto-extraction when returning from edit popup - track boolean parameter
  React.useEffect(() => {
    // Log the boolean parameter to track Extract Data vs Save button
    const isExtractDataClicked = location.state?.isExtractDataClicked;

    // Only proceed if we have valid state and it's Extract Data click and haven't processed this request yet
    if (
      location.state?.selectRowAndRunProcess &&
      location.state?.fileImportId &&
      location.state?.fromExtractData &&
      allFiles.length > 0 &&
      !hasProcessedExtractData.current
    ) {
      hasProcessedExtractData.current = true; // Mark as processed to prevent multiple executions
      const fileImportId = location.state.fileImportId;

      // Wait for files to load, then select the row and trigger extraction
      const timer = setTimeout(() => {
        // Find the target row from allFiles
        const targetRow = allFiles.find((file) => file.fileImportId === fileImportId);
        if (targetRow) {
          // Select the row
          handleSelectedRows([fileImportId]);

          // Store the fileId for the useEffect to pick up
          setPendingExtractFileId(fileImportId);
        } else {
          console.log("❌ File not found in BulkFormImport for fileImportId:", fileImportId);
        }
      }, 1000);

      return () => clearTimeout(timer);
    } else if (isExtractDataClicked === false) {
      console.log("💾 Save button clicked in BulkFormImport - no extraction needed");
    } else if (isExtractDataClicked === undefined) {
      console.log("🧹 State cleared in BulkFormImport - no action needed");
    } else if (hasProcessedExtractData.current) {
      console.log("🔄 Already processed extract data request in BulkFormImport - skipping");
    } else {
      console.log("⏳ Waiting for valid state or allFiles to load in BulkFormImport...");
    }
  }, [location.state, allFiles, handleSelectedRows, DataExtractProcess, history]);

  // Reset the processed flag when location state is cleared
  React.useEffect(() => {
    if (!location.state || Object.keys(location.state).length === 0) {
      hasProcessedExtractData.current = false;
    }
  }, [location.state]);

  // Watch for selectedRows changes and trigger extraction when pending file is selected
  React.useEffect(() => {
    if (pendingExtractFileId && selectedRows && selectedRows.includes(pendingExtractFileId)) {
      try {
        DataExtractProcess(allFiles);

        // Clear the pending fileId
        setPendingExtractFileId(null);

        // Clear the state after successful extraction start
        setTimeout(() => {
          history.replace(location.pathname, {});
        }, 1000);
      } catch (error) {
        console.error(
          "❌ Error calling DataExtractProcess from selectedRows watcher in BulkFormImport:",
          error
        );
      }
    }
  }, [
    selectedRows,
    pendingExtractFileId,
    allFiles,
    DataExtractProcess,
    history,
    location.pathname,
  ]);

  useEffect(() => {
    if (processContainerRef.current) {
      processContainerRef.current.scrollTop = processContainerRef.current.scrollHeight;
    }
  }, [processStates]);

  React.useEffect(() => {
    handleUserTraiLimit();
  }, []);

  React.useEffect(() => {
    //getAllFiles();
  }, [isSuccessPopup, notifications]);

  React.useEffect(() => {
    setLoading(true);

    getAllFiles();
  }, [defaultBusinessunit, searchValue, defaultOrganization, defaultUser]);

  const getAllFiles = async () => {
    const userDataJSON = localStorage.getItem("token");

    const userData = JSON.parse(userDataJSON);

    console.log(userData);

    try {
      const data = await getAllFilesList(
        history,
        defaultOrganization,
        defaultBusinessunit,
        defaultUser
      );

      const singleFormFiles = data.filter(
        (file) =>
          file.uploadType !== null &&
          file.uploadType !== undefined &&
          file.uploadType >= 2 &&
          file.uploadType <= 10
      );

      setAllFiles(singleFormFiles);

      const filteredRows = singleFormFiles.filter(
        (row) =>
          row.isProcessed === false &&
          row.fileName.toLowerCase().includes(searchValue.toLowerCase())
      );

      setRows(filteredRows);

      // Check if both current files and user audit history are empty

      if (data.length === 0) {
        try {
          const userAudit = await getUserFileAuditByUserId();

          if (userAudit.length === 0) {
            const refreshedData = await getAllFilesList(
              history,
              defaultOrganization,
              defaultBusinessunit,
              defaultUser
            );

            // Filter to only show single forms (upload type 2-10, exclude null)

            const refreshedSingleFormFiles = refreshedData.filter(
              (file) =>
                file.uploadType !== null &&
                file.uploadType !== undefined &&
                file.uploadType >= 2 &&
                file.uploadType <= 10
            );

            setAllFiles(refreshedSingleFormFiles);

            setRows(
              refreshedSingleFormFiles.filter(
                (row) =>
                  row.isProcessed === false &&
                  row.fileName.toLowerCase().includes(searchValue.toLowerCase())
              )
            );
          }
        } catch (auditError) {
          console.error("❌ Error checking user audit:", auditError);
        }
      }
    } catch (error) {
      console.error("Error fetching data:", error);

      if (error.message && error.message.includes("401")) {
        handleLogout(history);
      }
    } finally {
      // Ensure loading state is reset in all cases

      setLoading(false);
    }
  };

  React.useEffect(() => {
    const userDataJSON = localStorage.getItem("token");

    if (userDataJSON) {
      const userData = JSON.parse(userDataJSON);

      // Fetching data from the backend server

      fetch(`${BASE_URL}/BusinessUnits/${userData.organizationId}`, {
        headers: {
          Authorization: `Bearer ${userData.token}`,
        },
      })
        .then((response) => response.json())

        .then((data) => {
          const defaultOption = { id: "default", businessUnit: "Select a Business Unit" }; // Default option

          const transformedData = data.map((item) => ({
            id: item.businessUnitId,

            businessUnit: item.businessUnitName,
          }));

          // Prepend the default option to the beginning of the transformed data array

          const dataWithDefault = [defaultOption, ...transformedData];

          setBusinessUnits(dataWithDefault);

          if (dataWithDefault) {
            setUnits(dataWithDefault.map((item) => item.businessUnit));
          }

          // Here, you can transform the fetched data to match the format of your 'data' array.
        })

        .catch((error) => console.error("Error fetching data:", error));
    }
  }, []);

  React.useEffect(() => {
    if (editingData) {
      setFileName(editingData.fileName);

      setId(editingData.fileImportId);

      setProcessIdentifier(editingData.processIdentifier);

      setBusinessUnit(editingData.businessUnit);

      setUploadedDate(editingData.uploadedDate);

      setDataRows(editingData.numberOfRows);

      setTiers(editingData.numberOfTiers);
    }
  }, [editingData]);

  React.useEffect(() => {
    if (!process.includes(processIdentifier)) {
      setProcessIdentifier(process[0]);
    }
  }, [processIdentifier, process]);

  React.useEffect(() => {
    if (!units.includes(businessUnit)) {
      setBusinessUnit(units[0]);
    }
  }, [businessUnit, units]);

  const handleEdit = (row) => {
    history.push({
      pathname: "/displayAndEditFile",

      state: {
        someValue: row,

        fromPage: "bulkFormImport",

        returnPath: "/bulkFormImport",
      },
    });
  };

  useEffect(() => {
    const userDataJSON = localStorage.getItem("token");

    if (userDataJSON) {
      const userData = JSON.parse(userDataJSON);

      setUserName(userData.firstName + " " + userData.lastName);

      setuserId(userData.userId);
    }
  }, []);

  // Removed isRunProcessStarted useEffect - no longer needed with separate bulk processing context

  const generateUUID = () => {
    const newUUID = uuidv4(); // Generate a new UUID

    return newUUID;
  };

  // Helper function to add notifications with proper state management
  const addNotification = (type, message, filename, details = null) => {
    let newNotification;

    // Determine notification type and create appropriate notification
    if (type === "failed" || type === "error") {
      // Error notifications
      if (
        filename === "Bulk Upload Error" ||
        filename === "Bulk Upload Summary" ||
        filename === "Bulk Extraction Summary"
      ) {
        newNotification = NotificationService.systemError("Upload Error", message, details);
      } else {
        newNotification = NotificationService.fileUploadError(filename, message);
      }
    } else {
      // Success notifications
      if (filename === "Bulk Upload Summary" || filename === "Bulk Extraction Summary") {
        newNotification = NotificationService.systemInfo("Process Complete", message, details);
      } else if (message.includes("Extraction completed")) {
        newNotification = NotificationService.extractionSuccess(filename, undefined);
      } else {
        newNotification = NotificationService.fileUploadSuccess(filename, undefined, details);
      }
    }

    const updatedNotifications = [...notifications, newNotification];
    handleNotificationList(updatedNotifications);
  };

  // This function handles the file upload with parallel processing
  // Now using centralized handler from fileController
  const handleFileChange = async (event) => {
    await handleFileUpload(event, {
      mode: "bulkForm",
      userId: userId,
      userName: userName,
      businessUnitsList: businessUnitsList,
      defaultBusinessunit: defaultBusinessunit,
      setIsParallelUploading: setIsParallelUploading,
      setUploadProgress: setUploadProgress,
      rows: rows,
      setRows: setRows,
      notifications: notifications,
      handleNotificationList: handleNotificationList,
      addNotification: addNotification,
      getAllFiles: getAllFiles,
      storeReports: storeReports,
      getUploadTypeDisplayName: getUploadTypeDisplayName,
    });
  };

  // Register callback to refresh file list when all processing completes
  useEffect(() => {
    setOnAllCompleteCallback(() => {
      getAllFiles();
    });
  }, [setOnAllCompleteCallback, getAllFiles]);

  const handleRunProcess = async () => {
    // Check if any files are selected
    if (!selectedRows || selectedRows.length === 0) {
      alert(
        "Please select files to process. Use the checkboxes to select the files you want to extract data from."
      );
      return;
    }

    // Filter rows to find SELECTED files that are ready to process
    const readyToProcessFiles = rows.filter(
      (row) =>
        selectedRows.includes(row.fileImportId) && // Only process selected files
        row.isProcessed === false &&
        !processingStatus[row.fileImportId] && // Don't process files that are already in progress
        row.businessUnit &&
        row.isWithholding &&
        row.uploadType &&
        row.uploadType >= 2 &&
        row.uploadType <= 10
    );

    if (readyToProcessFiles.length === 0) {
      alert(
        "No selected files are ready to run process. Please ensure selected files have a client assigned, are recognized as withholding statements, and have a valid upload type (forms only)."
      );
      return;
    }

    // Clear selections after adding to process
    handleSelectedRows([]);
    setTemporarySelectedRows([]);

    try {
      // Progress update callback
      const onProgressUpdate = (fileId, status, message) => {
        // Add notifications for extraction progress
        if (status === "completed") {
          addNotification(
            "success",
            `Extraction completed: ${message}`,
            rows.find((r) => r.fileImportId === fileId)?.fileName || "Unknown file"
          );
        } else if (status === "failed") {
          addNotification(
            "failed",
            `Extraction failed: ${message}`,
            rows.find((r) => r.fileImportId === fileId)?.fileName || "Unknown file"
          );
        }

        // If file completed successfully, update the local rows state to mark it as processed
        if (status === "completed") {
          setRows((prevRows) =>
            prevRows.map((row) =>
              row.fileImportId === fileId ? { ...row, isProcessed: true } : row
            )
          );
        }
      };

      // Process all files in parallel using the context provider
      await startProcessing(readyToProcessFiles, onProgressUpdate, (results) => {
        // Process results and update UI
        const successful = results.filter((r) => r.success);
        const failed = results.filter((r) => !r.success);

        // Show final summary notification
        const summaryType =
          failed.length === 0 ? "success" : successful.length === 0 ? "failed" : "success";
        const summaryMessage =
          failed.length === 0
            ? `All ${successful.length} files extracted successfully and sent to Extraction Review`
            : `Bulk extraction completed: ${successful.length} successful, ${failed.length} failed`;

        addNotification(summaryType, summaryMessage, "Bulk Extraction Summary");

        // Refresh data to show updated status - reload the files list to remove completed files
        getAllFiles();
      });
    } catch (error) {
      console.error("Error in parallel bulk processing:", error);

      addNotification(
        "failed",
        `Bulk extraction process failed: ${error.message}`,
        "Bulk Extraction Error"
      );
    }
  };

  const handleColumnCheckboxChange = (e) => {
    if (e.target.checked) {
      // First check if there are any files that are ready to be selected

      const readyToSelectFiles = rows

        .filter((item) => item.isProcessed === false)

        .slice(startIndex, endIndex)

        .filter(
          (row) =>
            row.businessUnit &&
            row.isWithholding &&
            row.uploadType &&
            row.uploadType >= 2 &&
            row.uploadType <= 10
        );

      if (readyToSelectFiles.length === 0) {
        alert(
          "No files are ready to run process. Please ensure files have a client assigned and upload type is selected."
        );

        return;
      }

      setIsCheckedAll(e.target.checked);

      // Select all rows in the range that satisfy the conditions

      if (extractLimit === null || extractLimit === undefined) {
        const selectedInRange = readyToSelectFiles.map((row) => row.fileImportId);

        handleSelectedRows(selectedInRange);

        setTemporarySelectedRows(selectedInRange);

        //Added for user control
      } else {
        const currentlySelectedCount = allFiles.filter((row) => row.isProcessed === true).length;

        const remainingSlots = extractLimit - currentlySelectedCount;

        if (remainingSlots <= 0) {
          alert(
            `You have reached your ${extractLimit} document limit for the trial. Please contact XXX to extend your license.`
          );

          return;
        }

        const rowsToAdd = readyToSelectFiles

          .slice(0, remainingSlots)

          .map((row) => row.fileImportId);

        // If you want to show a message about partial selection

        if (readyToSelectFiles.length > remainingSlots) {
          alert(
            `Only ${remainingSlots} further documents can be extracted. The limit for your trial version is ${extractLimit}.`
          );
        }

        handleSelectedRows(rowsToAdd);

        setTemporarySelectedRows(rowsToAdd);
      }
    } else {
      setIsCheckedAll(false);

      // Deselect all rows

      handleSelectedRows([]);

      setTemporarySelectedRows([]);
    }
  };

  const handleRowCheckboxChange = (row) => {
    // Check if file is currently being processed
    if (processingStatus[row.fileImportId]) {
      alert("This file is currently being processed. Please wait until processing is complete.");
      return;
    }

    // Check for mandatory fields: businessUnit and uploadType

    if (!row.businessUnit || !row.uploadType) {
      const missingFields = [];

      if (!row.businessUnit) missingFields.push("business unit");

      if (!row.uploadType) missingFields.push("upload type");

      const userConfirmed = window.confirm(
        `This file is missing required information: ${missingFields.join(" and ")}. Would you like to edit this file to add the missing information?`
      );

      if (userConfirmed) {
        handleEdit(row);
      }

      return;
    }

    // Check how many rows are currently selected

    const currentlySelectedCount = allFiles.filter((row) => row.isProcessed === true).length;

    // Calculate how many more rows can be added

    const remainingSlots = extractLimit - currentlySelectedCount;

    if (row.isWithholding === false) {
      alert(
        "This file could not been recognized as a withholding statement. Please try another file."
      );

      return;
    }

    let newRows = [...temporarySelectedRows];

    // Check if the row ID is already present in the array

    if (newRows.includes(row.fileImportId)) {
      // Remove the ID if it exists

      newRows = newRows.filter((id) => id !== row.fileImportId);
    } else {
      if (extractLimit === null || extractLimit === undefined) {
        newRows = [...newRows, row.fileImportId];
      } else {
        if (newRows.length >= remainingSlots) {
          alert(
            `Only ${remainingSlots} further documents can be extracted. The limit for your trial version is ${extractLimit}.`
          );

          return;
        }

        newRows = [...newRows, row.fileImportId];
      }
    }

    // Update the state and handle the selection

    setTemporarySelectedRows(newRows);

    handleSelectedRows(newRows);
  };

  // Use centralized delete service
  const handleDelete = async () => {
    if (!selectDeletedItem) {
      alert("No file selected for deletion.");
      return;
    }

    const rowToDelete = rows.find((row) => row.fileImportId === selectDeletedItem);

    await handleFileDelete({
      fileImportId: selectDeletedItem,
      fileName: rowToDelete?.fileName || "Unknown file",
      rows,
      setIsDeleting,
      getAllFiles,
      setIsPopupOpen,
    });
  };

  const handlePageChange = (event, newPage) => {
    setCurrentPage(newPage);

    setStartIndex((parseInt(newPage) - 1) * rowsPerPage);

    setEndIndex((parseInt(newPage) - 1) * rowsPerPage + rowsPerPage);
  };

  // Calculate total pages

  const handleRowsPerPageChange = (event) => {
    updateRowNumberOfPages(parseInt(event.target.value));

    setRowsPerPage(parseInt(event.target.value));

    setStartIndex(0);

    setCurrentPage(1);

    setEndIndex(parseInt(event.target.value));

    // Reset to the first page
  };

  const LoadingOverlay = () => (
    <div
      style={{
        position: "fixed",

        top: 0,

        width: isMenuOpen === true ? "calc(100vw - 240px)" : "calc(100vw - 72px)",

        left: isMenuOpen ? "240px" : "72px",

        height: "100%",

        zIndex: 9999,

        backgroundColor: "rgba(255, 255, 255, 0.5)", // You can adjust the color and opacity as needed
      }}
    >
      <div
        style={{
          position: "absolute",
          bottom: "50%",
          right: "50%",
          transform: "translate(-50%, -50%)",
        }}
      >
        <Loader />
      </div>
    </div>
  );

  // Filter columns to exclude 'entityUniqueIdentifier' if all its values are empty

  return (
    <div style={screenHeaderStyle(isMenuOpen)}>
      {/* Loading overlay during deletion */}

      {isDeleting && (
        <div
          style={{
            position: "fixed",

            top: 0,

            left: 0,

            right: 0,

            bottom: 0,

            backgroundColor: "rgba(0, 0, 0, 0.1)",

            zIndex: 999,

            display: "flex",

            alignItems: "center",

            justifyContent: "center",
          }}
        >
          <div
            style={{
              backgroundColor: "white",

              padding: "20px",

              borderRadius: "8px",

              display: "flex",

              alignItems: "center",

              gap: "10px",

              boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
            }}
          >
            <CircularProgress size={24} style={{ color: "#2aa7e0" }} />

            <span style={{ fontFamily: fontFamily, fontSize: "14px" }}>Deleting file...</span>
          </div>
        </div>
      )}

      {/* <Loader/> */}

      <div
        style={{
          marginTop: paddingAndMargin.headerTopHeight,
          marginBottom: paddingAndMargin.headerBelowHeight,
          display: "flex",
          alignItems: "center",
          flexDirection: "row",
          marginRight: 30,
          marginLeft: 30,
        }}
      >
        <SearchInput
          value={searchValue}
          onChange={(e) => {
            setSearchValue(e.target.value);
          }}
          onClick={() => {
            setSearchValue("");
          }}
        />

        {/* Pagination Controls */}

        {rows.filter((item) => item.isProcessed === false).length > 5 && (
          <>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <div>
                <label
                  style={{
                    fontFamily: "Roboto, sans-serif", // Add this line

                    fontWeight: 400,
                    fontSize: 12,
                  }}
                >
                  Displayed per page:&nbsp;
                  <select
                    className="pagination-select"
                    style={{ width: 50 }}
                    value={rowsPerPage}
                    onChange={handleRowsPerPageChange}
                  >
                    {[5, 10, 15, 20, 25, 30].map((pageSize) => (
                      <option key={pageSize} value={pageSize}>
                        {pageSize}
                      </option>
                    ))}
                  </select>
                </label>
              </div>
            </div>
          </>
        )}

        {/* Centered buttons */}

        <div style={{ display: "flex", alignItems: "center", marginLeft: "auto", gap: "10px" }}>
          <Button variant="contained" component="label" style={reviewScreenButtonWithOutColor(155)}>
            Import Forms
            {/* Hidden file input */}
            <input type="file" hidden multiple accept=".pdf" onChange={handleFileChange} />
          </Button>

          <Button
            style={reviewScreenButtonWithColor(140)}
            onClick={() => {
              if (extractLimit === null || extractLimit === undefined) {
                handleRunProcess();
              } else if (allFiles.filter((row) => row.isProcessed === true).length < extractLimit) {
                handleRunProcess();
              } else {
                alert(
                  "Your free plan is over. Please email us at contact@complyexchange.com to arrange a new subscription."
                );
              }
            }}
            variant="contained"
          >
            Extract Data
          </Button>
        </div>
      </div>

      <div
        style={{
          margin: "10px 40px",

          padding: "10px",

          backgroundColor: "#E3F2FD",

          borderRadius: "6px",

          fontSize: "14px",

          color: "#1976D2",

          fontFamily: fontFamily,
        }}
      >
        <strong>Bulk Form Import:</strong> Only W-8, W-9, Self-cert, Form 8233 are supported.
        Withholding Statement and Pack with Forms should use the regular File Import.
      </div>

      {/* Main table container with fixed height */}
      <div
        style={{
          height: "calc(100vh - 270px)",
          display: "flex",
          flexDirection: "column",
          marginLeft: 0,
          marginRight: 0,
        }}
      >
        {/* Columns - Fixed Header */}
        <div class="columntitlesRowStyle" style={{ flexShrink: 0 }}>
          <div>
            <Checkbox
              size="small"
              checked={isCheckedAll}
              onChange={(event) => {
                if (extractLimit === null || extractLimit === undefined) {
                  handleColumnCheckboxChange(event);
                } else if (
                  allFiles.filter((row) => row.isProcessed === true).length < extractLimit
                ) {
                  handleColumnCheckboxChange(event);
                } else {
                  alert(
                    "Your free plan is over. Please email us at contact@complyexchange.com to arrange a new subscription."
                  );
                }
              }}
              disabled={rows.length > 0 ? false : true}
              style={{ color: InstaColors.white }}
            />
          </div>

          {columns.map((column) => (
            <div key={column.field} class="columntitlesStyle">
              <UpperLowerText text={column.headerName} />
            </div>
          ))}
        </div>

        {/* Table rows container - Scrollable */}
        {loading ? (
          <div style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center" }}>
            <Loader />
          </div>
        ) : rows.length === 0 ? (
          <div
            className="no-record"
            style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center" }}
          >
            No single forms available. Only W-8, W-9, Self-cert, and Form 8233 are shown in Bulk
            Form Import.
          </div>
        ) : (
          <div style={{ flex: 1, overflowY: "auto", overflowX: "hidden" }}>
            {filteredRows.slice(startIndex, endIndex).map((row) => (
              <div key={row.fileImportId} class="columnRowStyle">
                <div>
                  <Checkbox
                    size="small"
                    title="Select"
                    onChange={() => {
                      if (extractLimit === null || extractLimit === undefined) {
                        handleRowCheckboxChange(row);
                      } else if (
                        allFiles.filter((row) => row.isProcessed === true).length < extractLimit
                      ) {
                        handleRowCheckboxChange(row);
                      } else {
                        alert(
                          "Your free plan is over. Please email us at contact@complyexchange.com to arrange a new subscription."
                        );
                      }
                    }}
                    style={{
                      color: processingStatus[row.fileImportId] ? "#ccc" : "#2aa7e0",
                    }}
                    disabled={processingStatus[row.fileImportId]}
                    checked={selectedRows.includes(row.fileImportId)}
                  />
                </div>

                {columns.map((column) => (
                  <div
                    key={column.field}
                    title={
                      column.headerName === "Uploaded Date"
                        ? formatDate(row[column.field])
                        : column.field === "uploadType"
                          ? getUploadTypeDisplayName(row[column.field])
                          : row[column.field]
                    }
                    class="columnValuesStyle"
                  >
                    {column.field === "processQueue" ? (
                      <div style={{ display: "flex", alignItems: "flex-end" }}>
                        <div style={{ marginRight: "auto" }}></div>

                        <EditButton
                          onClick={() => {
                            if (processingStatus[row.fileImportId]) {
                              alert("Cannot edit while file is being processed.");
                              return;
                            }
                            handleEdit(row);
                          }}
                          style={{
                            opacity: processingStatus[row.fileImportId] ? 0.5 : 1,
                            cursor: processingStatus[row.fileImportId] ? "not-allowed" : "pointer",
                          }}
                        />

                        <DeleteButton
                          onClick={() => {
                            if (processingStatus[row.fileImportId]) {
                              alert("Cannot delete while file is being processed.");
                              return;
                            }
                            setIsPopupOpen(true);
                            setSelectDeletedItem(row.fileImportId);
                          }}
                          style={{
                            opacity: processingStatus[row.fileImportId] ? 0.5 : 1,
                            cursor: processingStatus[row.fileImportId] ? "not-allowed" : "pointer",
                          }}
                        />
                      </div>
                    ) : column.field === "processStatus" ? (
                      <div>
                        {processingStatus[row.fileImportId] ? (
                          <>
                            <div
                              style={{
                                float: "left",
                                marginRight: 10,
                              }}
                            >
                              <LoaderComponent />
                            </div>
                            <span className="status status-primary">Processing</span>
                          </>
                        ) : row.businessUnit &&
                          row.isWithholding &&
                          row.uploadType &&
                          row.uploadType >= 2 &&
                          row.uploadType <= 10 ? (
                          <span className="status status-success">Ready to process</span>
                        ) : (
                          <span className="status status-danger">Information required</span>
                        )}
                      </div>
                    ) : column.field === "uploadType" ? (
                      getUploadTypeDisplayName(row[column.field])
                    ) : column.headerName === "Uploaded Date" ? (
                      formatDate(row[column.field])
                    ) : (
                      row[column.field]
                    )}
                  </div>
                ))}
              </div>
            ))}
          </div>
        )}
      </div>

      {/* The div that fills the remaining height */}

      <div style={{ marginBottom: "10px" }}></div>

      {/* Render the loader when isLoading is true */}

      {isLoading && <LoadingOverlay />}

      <DeleteModal
        open={isPopupOpen}
        isDeleting={isDeleting}
        onClose={() => setIsPopupOpen(false)}
        onDelete={handleDelete}
        deleteButtonStyle={reviewScreenButtonWithColor(100)}
        cancelButtonStyle={reviewScreenButtonWithOutColor(100)}
      />

      <Modal
        open={isSuccessPopup}
        // onClose={() => handleIsSuccessPopup(false)}

        onClose={null}
        disableBackdropClick={true}
        aria-labelledby="delete-confirmation-modal-title"
        aria-describedby="delete-confirmation-modal-description"
        style={{
          border: "none", // Remove border

          background: "transparent", // Remove background color

          boxShadow: "none",
        }}
      >
        <div
          style={{
            top: "50%",

            left: "50%",

            border: "none",

            transform: "translate(-50%, -50%)",

            position: "absolute",

            width: "450px",

            padding: "20px",

            outline: "none",

            backgroundColor: "white",

            boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",

            borderRadius: "8px",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "start",
            }}
          >
            <CheckCircleIcon
              style={{ height: 40, width: 40, color: "green" }}
              className="text-green-500 mb-4 custom-bounce"
            />

            <h6 style={{ color: "#2aa7e0", fontFamily: fontFamily, marginBottom: 10 }}>
              {successFilename ?? ""}
            </h6>

            <h6 style={{ color: "#2aa7e0", fontFamily: fontFamily, marginBottom: 15 }}>SUCCESS</h6>
          </div>

          {/* <div style={{ height: '1px', width: '410px', backgroundColor: '#2aa7e0', marginBottom: '20px', marginRight: '10px', }}></div> */}

          <div>
            <div style={{ marginBottom: "20px" }}>
              <div
                style={{
                  marginLeft: "30px",
                  marginRight: "30px",
                  fontFamily: fontFamily,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  textAlign: "center",
                }}
              >
                Extraction completed. The file has been successfully pushed to Extraction Review.
              </div>
            </div>

            <div style={{ display: "flex", justifyContent: "center", gap: "10px" }}>
              <Button
                disableElevation
                variant="contained"
                style={reviewScreenButtonWithColor(160)}
                onClick={() => {
                  history.push({
                    pathname: "/extractionReview",
                  });

                  handleIsSuccessPopup(false);
                }}
              >
                Extraction Review
              </Button>

              <Button
                disableElevation
                variant="contained"
                style={reviewScreenButtonWithColor(180)}
                onClick={() => {
                  handleIsSuccessPopup(false);

                  getAllFiles();
                }}
              >
                Close
              </Button>
            </div>
          </div>
        </div>
      </Modal>

      {/* Parallel Upload Progress Modal */}
      <ParallelProcessModal
        open={isParallelUploading}
        uploadProgress={uploadProgress}
        title="Parallel Bulk Form Upload in Progress"
        uploadingMessage="bulk forms simultaneously..."
        processingMessage="Single forms are being processed in parallel for faster upload"
      />

      <ConditionalPagination
        itemCount={filteredRows.length}
        itemsPerPage={rowsPerPage}
        threshold={rowsPerPage}
        paginationProps={{
          page: currentPage,
          onChange: handlePageChange,
          style: { marginLeft: "auto", marginRight: 10, marginTop: "auto", marginBottom: 10 },
        }}
      />
    </div>
  );
}
